import Chart from 'chart.js/auto';
import def_day_lines, { xAxisConfig, tooltipCallbacks, enableTouchPan } from './graph_utils.js';

const suggestedMax = 50.;

export default function graph_wind(ser, times, ff){
  var module = new Array(ff.length);
  var rafale = new Array(ff.length);
  var direction = new Array(ff.length);
  var ann = new Array(ff.length);
  const knams =  0.514791
  for(let i=0; i < ff.length; i++){
    module[i]=ff[i][0]/knams;
    if(ff[i][1]){
      rafale[i]=ff[i][1]/knams;
      if(rafale[i]-module[i] < .1){
	rafale[i]=null;
      }
    }else{
      rafale[i]=null;
    }
    direction[i]=ff[i][2];
  }
  const data = {
    datasets: [
      {
	label: 'Force',
	data: times.map((t, i) => ({ x: t.getTime(), y: module[i] })),
	borderColor: 'rgb(100, 100, 192)',
	lineTension: 0.3
      },
      {
	label: 'Rafale',
	data: times.map((t, i) => ({ x: t.getTime(), y: rafale[i] })),
	borderColor: 'rgb(192, 50, 50)',
	lineTension: 0.3
      }
    ]
  };

  const ctx = document.getElementById('id_series_canvas');
  if(ser.chart){
    ser.chart.destroy();
  }
  ser.chart = new Chart(ctx, {
    type: 'line',
    data: data,
    options: {
      animations: false,
      responsive: true,
      scales: {
        x: xAxisConfig(times),
	y: {
	  title: {
	    display: true,
	    text: '[Noeuds]'
	  },
	  min: 0 ,
	  suggestedMax: suggestedMax
	}
      },
      plugins: {
	tooltip: { callbacks: tooltipCallbacks },
	zoom: {
	  zoom: {
	    wheel: {
	      enabled: true
	    },
	    pinch: {
	      enabled: true
	    },
	    mode: "x",
	    speed: 100
	  },
	  pan: {
	    enabled: true,
	    mode: "x",
	    speed: 100
	  }
	}
      }
    }
  });

  // Add wind direction via text annotation
  for(var i=0; i < ff.length; i++){
    ann[i]={
      type: 'label',
      color: 'grey',
      xValue: times[i].getTime(),
      yValue: .95*suggestedMax,
      content: ['➙'],
      rotation: direction[i]-270,
      font: {
        size: 28
      }
    }
  }

  def_day_lines(times, ann);

  ser.chart.options = {
    maintainAspectRatio: false,
    animations: false,
    responsive: true,
    scales: {
      x: xAxisConfig(times),
      y: {
	title: {
	  display: true,
	  text: '[Noeuds]'
	},
	min: 0 ,
	suggestedMax: 50,
      }
    },
    plugins: {
      tooltip: { callbacks: tooltipCallbacks },
      annotation: {
	annotations: ann
      },
      zoom: {
	zoom: {
	  wheel: {
	    enabled: true
	  },
	  pinch: {
	    enabled: true
	  },
	  mode: "x",
	  speed: 100
	},
	pan: {
	  enabled: true,
	  mode: "x",
	  speed: 100
	}
      }
    }
  };
  ser.chart.update();
  enableTouchPan(ser.chart);
}
